import { validationHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'


export function validateQuotation(values) {
    const errors = {}

    if (validationHelper.isDefaultSelected(values.customer) || validationHelper.stringIsNullOrEmpty(values.customer)) {
        errors.customer = messages.MANDATORY_FIELD
    }
    if (validationHelper.isDefaultSelected(values.store) || validationHelper.stringIsNullOrEmpty(values.store)) {
        errors.store = messages.MANDATORY_FIELD
    }
    if (validationHelper.stringIsNullOrEmpty(values.expirationDate)) {
        errors.expirationDate = messages.MANDATORY_FIELD
    }
    if (!validationHelper.isValueAcepted(values.totalPrice)) {
        errors.totalPrice = messages.MANDATORY_FIELD
    }

    return errors
}

export function validateItem(values) {
    const errors = {}

    if (validationHelper.stringIsNullOrEmpty(values.id) || validationHelper.isDefaultSelected(values.id)) {
        errors.id = messages.MANDATORY_FIELD
    }

    if (!validationHelper.isValueAcepted(values.quantity) || validationHelper.stringIsNullOrEmpty(values.quantity)) {
        errors.quantity = messages.MANDATORY_FIELD
    }


    return errors
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationAdd/_validate.js